<template>
  <div class="cardTicket-list">
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form">
        <el-form-item  label="手机号码" prop="userPhone">
          <el-input clearable v-model="form.userPhone" placeholder="发送手机号码"></el-input>
        </el-form-item>

        <el-form-item label="发送时间" class="date" >
          <el-date-picker
            v-model="form.date"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="handleInputChange">查询</el-button>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="用户账号" align="center"></el-table-column>
        <el-table-column prop="userPhone" label="手机号码" align="center"></el-table-column>
        <el-table-column label="短信类型" align="center">
          <template slot-scope="scope">
            {{ shortMessageObj[scope.row.shortMessage] }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发送时间" align="center"></el-table-column>
        <el-table-column label="发送结果" align="center">
          <template slot-scope="scope">
            {{ scope.row.sendResult === 'SUCCESS' ? '成功' : '失败' }}
          </template>
        </el-table-column>
        <el-table-column prop="overdueIntegral" label="过期积分" align="center"></el-table-column>
        <el-table-column prop="overdueTime" label="过期时间" align="center"></el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { getAdminShortMessageList } from '@/api/template';
import Pagination from '@/components/Pagination';

export default {
  data() {
    return {
      form: {
        userPhone: '',
        date: [],
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      shortMessageObj: {
        1: '积分过期提醒',
      },
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 参数处理
    DealParameter() {
      const { date, userPhone } = this.form;
      const [beginTime, endTime] = date;
      return {
        userPhone,
        beginTime,
        endTime,
      };
    },
    getList() {
      this.loading = true;
      const data = this.DealParameter();
      return getAdminShortMessageList({
        ...data,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
  },
};
</script>
